import { sealing } from '@/env'
import { useSystemInfo } from '@/store'
import showPopup from '@/components/showPopup'
import Reload from '@/components/common/Reload.vue'
import { getVersionStatus } from '@/api/config'
export const updateChecker = (
  interval: number = 300000,
  onUpdate: () => void,
) => {
  let timer: number | null = null
  let hc: string | null = null

  async function check() {
    try {
      const response = await getVersionStatus()
      if (!hc) {
        hc = response.data.hashCode
        return
      }

      const hasUpdate =
        response &&
        response.data &&
        response.data.hashCode &&
        response.data.hashCode !== hc

      hc = response.data.hashCode

      if (hasUpdate) onUpdate?.()
    } catch (error) {
      console.error('check update error:', error)
    }
  }

  return {
    start() {
      if (sealing) {
        console.log('no need to check update in sealing or APL')
        return
      }
      const updateConfig = useSystemInfo().updateConfig
      // console.log('start updateConfig----------start', updateConfig)
      this.stop()
      timer = setInterval(
        //接口配置获取检测时间
        check,
        Number(updateConfig?.WebUpdateVersionInterval) * 60 * 1000 || interval,
      )
    },
    stop() {
      timer && clearInterval(timer)
    },
    forceCheck() {
      check()
    },
  }
}

export const needUpdate = ref('')
export const checker = updateChecker(300000, () => {
  const updateConfig = useSystemInfo().updateConfig
  const WebUpdateVersionPopUp = updateConfig?.WebUpdateVersionPopUp === 'true'
  // console.log('open updateConfig----------open', updateConfig)
  if (['home', 'promocao', 'meu'].some((n) => location.pathname.includes(n))) {
    if (WebUpdateVersionPopUp) {
      showPopup(Reload, {
        closeOnClickOverlay: false,
      })
    } else {
      location.reload()
    }
  } else {
    needUpdate.value = WebUpdateVersionPopUp ? 'popup' : 'reload'
    // console.log('need update')
  }
})
